import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  videoWrapper: {
    zIndex: 1,
  },
  video: {
    width: 330,
    marginTop: theme.spacing(2),
    borderRadius: theme.spacing(1.5),
  },
  title: {
    color: theme.palette.common.white,
    fontSize: 18,
    textAlign: 'center',
  },
  textDescription: {
    color: theme.palette.common.white,
    lineHeight: 1.3,
    fontSize: 14,
  },
}));
